import { render } from "./Incidents.vue?vue&type=template&id=766d676b"
import script from "./Incidents.vue?vue&type=script&lang=js"
export * from "./Incidents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__